/**
 * User Message Service
 * Handles API requests related to user messages (announcements)
 */
import apiClient from './apiClient';

// Define the base URL for user message service
const baseUrl = '/api/supplier/user-message';

const userMessageService = {
  /**
   * Get active messages for current user
   * @returns {Promise} - Response with active messages
   */
  async getActiveMessages() {
    return apiClient.get(`${baseUrl}/active-messages`)
      .then(response => response.data);
  },

  /**
   * Accept/acknowledge a message
   * @param {string} messageId - Message ID to accept
   * @returns {Promise} - Response from API
   */
  async acceptMessage(messageId) {
    return apiClient.post(`${baseUrl}/accept-message/${messageId}`)
      .then(response => response.data);
  }
};

export default userMessageService;
